'use strict';

module.exports = function (ngModule) {
    ngModule.directive('sidebar', require('./sidebar'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/sidebar/index.js
 **/